import Node from './node';

export default class PlaceholderText extends Node {
  clone() {
    return new PlaceholderText(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
